import type { UpshotCode } from '@openx/types/troubleshootingFunnel.ts';
import { useTranslation } from 'react-i18next';

export const useUpshotCodesTranslations = (): Record<UpshotCode, string> => {
  const { t } = useTranslation();

  return {
    'Ad Pod Bid Duplication': t('Ad pod rules prevent duplicate domains from bidding.'),
    'AQ Error': t(
      'The bid was blocked due to policy or quality rules (e.g., brand, category, or eligibility restrictions).'
    ),
    'Autoplay blocked': t('Autoplay video or audio is not allowed on this inventory.'),
    'Bid Error': t(
      'The bid could not be processed due to a technical issue in the bid payload, markup, tracking URL, auction compatibility, or external bid handling.'
    ),
    Block: t('Targeting/exclusion rules conflict and prevent selection.'),
    'Buyer in OE': t('The buyer is not eligible to participate in the open auction for this setup.'),
    'Creative - Attribute/Industry': t(
      'The creative\u2019s category or attributes are not allowed for this inventory.'
    ),
    'Creative - Blocked': t('The creative was excluded by settings in the ad request.'),
    'Creative - Duration Missmatch': t('The video duration does not match the placement requirements.'),
    'Creative - Duration too long': t('Video duration exceeds the maximum allowed.'),
    'Creative - Duration too short': t('Video duration is below the minimum required.'),
    'Creative - Maleware detected': t('The creative was flagged as malware.'),
    'Creative - not SSL Safe': t('The creative is not secure and cannot run on SSL inventory.'),
    'Creative - Rejected': t('The creative did not pass review or policy checks.'),
    'Creative - Size missmatch': t('Creative size does not match allowed sizes in the request.'),
    'Creative - Size too large': t('The creative file size exceeds the allowed limit.'),
    'Creative - Technical': t(
      'The creative does not meet technical requirements (e.g., scan status, bitrate, or request limits).'
    ),
    'Creative - Type': t('The creative format is not supported for this placement.'),
    'Creative - Type not supported': t('The creative type or MIME format is not supported.'),
    'Currency conversion failed': t('Currency conversion could not be completed.'),
    'Frequency Capper': t('Delivery was limited due to frequency cap settings.'),
    'Low Price': t('The bid price was too low, or there was high auction competition.'),
    'No Bid': t('DSP returned no bid (buyer chose not to participate).'),
    'No Deal On Bid': t('The bid did not include a valid deal ID or it could not be matched.'),
    'Self Compete': t('Multiple bids from the same buyer/seat compete and only one can win.'),
    'Unbranded request': t('The brand could not be identified, and this inventory requires a recognized brand.'),
    'User initiated video blocked': t('This inventory does not allow user-initiated video.'),
    Other: t('There was another issue that prevented a fill.'),
  };
};
